module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES6BUC3']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "details1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6BUC3']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codinput",
      "name": "coddesc_codinput"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codinput) + _vm._s(_vm.detail.tab1.desc_codinput))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6BUC3']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codempid",
      "name": "coddesc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codempid) + " - " + _vm._s(_vm.detail.tab1.desc_codempid))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6BUC3']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "dtereq",
      "name": "dtereq"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtereq)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6BUC3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "dtework",
      "name": "dtework"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtework)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6BUC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codshift",
      "name": "coddesc_codshift"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codshift) + " - " + _vm._s(_vm.detail.tab1.desc_codshift))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6BUC3']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "tim_sch_btw",
      "name": "tim_sch_btw"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timin_sch) + " - " + _vm._s(_vm.detail.tab1.timout_sch))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6BUC3']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "dteine",
      "name": "dteine"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dteine)))]), _vm._v(" "), _c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "timine",
      "name": "timine"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timine))]), _vm._v(" "), _c('div', {
    staticClass: "detail-time-line"
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "dteoute",
      "name": "dteoute"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dteoute)))]), _vm._v(" "), _c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "timoute",
      "name": "timoute"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timoute))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6BUC3']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "dtein",
      "name": "dtein"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtein)))]), _vm._v(" "), _c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "timin",
      "name": "timin"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timin))]), _vm._v(" "), _c('div', {
    staticClass: "detail-time-line"
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "dteout",
      "name": "dteout"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dteout)))]), _vm._v(" "), _c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "timout",
      "name": "timout"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timout))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6BUC3']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codshift2",
      "name": "coddesc_codshift2"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codshift2) + " - " + _vm._s(_vm.detail.tab1.desc_codshift2))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6BUC3']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "tim_sch_btw2",
      "name": "tim_sch_btw2"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timin_sch2) + " - " + _vm._s(_vm.detail.tab1.timout_sch2))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6BUC3']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "dteinr",
      "name": "dteinr"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dteinr)))]), _vm._v(" "), _c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "timinr",
      "name": "timinr"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timinr))]), _vm._v(" "), _c('div', {
    staticClass: "detail-time-line"
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "dteoutr",
      "name": "dteoutr"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dteoutr)))]), _vm._v(" "), _c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "timoutr",
      "name": "timoutr"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timoutr))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6BUC3']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "dtein2",
      "name": "dtein2"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtein2)))]), _vm._v(" "), _c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "timin2",
      "name": "timin2"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timin2))]), _vm._v(" "), _c('div', {
    staticClass: "detail-time-line"
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "dteout2",
      "name": "dteout2"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dteout2)))]), _vm._v(" "), _c('div', {
    staticClass: "detail-time",
    attrs: {
      "id": "timout2",
      "name": "timout2"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timout2))])])])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6BUC3']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codreqst",
      "name": "coddesc_codreqst"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codreqst) + " - " + _vm._s(_vm.detail.tab1.desc_codreqst))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6BUC3']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100 txtarea-width response-full-width",
    attrs: {
      "id": "remark",
      "name": "remark"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.remark))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES6BUC3']['140']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "details2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_c('div', {}, [_vm._v(_vm._s(_vm.labels['HRES6BUC4']['10']))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6BUC4']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codempid",
      "name": "coddesc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab2.detail.codempid) + " - " + _vm._s(_vm.detail.tab2.detail.desc_codempid))])])])]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.tab2Table,
      "data": _vm.detail.tab2.table,
      "searchDisp": false,
      "tablePageDisp": false
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details3"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES6BUC4']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "details3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('hrms-calendar-work-time', {
    attrs: {
      "codempid": _vm.detail.tab1.codempid
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b3978c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6bu/detail.vue
// module id = 3834
// module chunks = 1